import type { Mover } from '../../api/types'
import { CHART_TYPE_LABELS } from '../../hooks/useMeta'
import { AppCell } from '../AppCell'
import { MovementBadge } from '../MovementBadge'

export function MoversTable({ rows, kind }: { rows: Mover[]; kind: 'gainers' | 'losers' | 'new' }) {
	return (
		<div className="table-scroll">
			<table>
				<thead>
					<tr>
						<th>App</th>
						<th>Chart</th>
						<th className="num">Then</th>
						<th className="num">Now</th>
						<th className="num">Change</th>
					</tr>
				</thead>
				<tbody>
					{rows.map((r) => (
						<tr key={`${r.chart.id}:${r.app.id}`}>
							<td style={{ maxWidth: 0, width: '55%' }}>
								<AppCell app={r.app} />
							</td>
							<td className="small muted">
								{r.chart.genreName === 'App Store' || r.chart.genreName === 'Mac App Store' ? 'All' : r.chart.genreName}{' '}
								· {CHART_TYPE_LABELS[r.chart.type]}
							</td>
							<td className="num">{r.previousRank ?? '—'}</td>
							<td className="num">{r.rank ?? 'out'}</td>
							<td className="num">
								{kind === 'new' ? (
									<MovementBadge movement="new" />
								) : r.change === null ? (
									<span className="down">dropped</span>
								) : (
									<MovementBadge movement={r.change} />
								)}
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	)
}
